//用户相关的请求
import { request } from "@/utils";

//登录
export function loginAPI(formData) {
  return request({
    url: '/crostars-user/login',
    method: 'POST',
    data: formData
  })
}

//注册
export function registerAPI(formData) {
  return request({
    url: '/crostars-user/register',
    method: 'POST',
    data: formData
  })
}

//测试：获取用户信息
export function getProfileAPI() {
  return request({
    url: '/crostars-user/get-user-by-token',
    method: 'GET',
  })
}

//通过companyId获取同一公司的员工
export function getUserListByCompanyIdAPI(companyId) {
  return request({
    url: `/crostars-user/get-user-list-by-company-id?companyId=${companyId}`,
    method: 'POST',
  })
}

// 获取所有用户（用于多选关联项目设计 / 执行人员）
export function getAllUsersListAPI(){
  return request({
    url:'/crostars-user/get-users-list',
    method:'GET'
  })
}

//通过companyId获取同一公司的员工
export function getUserListByDepartmentIdAPI(departmentId) {
  return request({
    url: `/crostars-user/get-user-list-by-department-id?departmentId=${departmentId}`,
    method: 'POST',
  })
}

//通过userId获取同一公司的Manager
export function getManagerListByUserIdAPI(userId) {
  return request({
    url: `/crostars-user/get-manager-list-by-userId?userId=${userId}`,
    method: 'POST'
  })
}

//通过userId获取同一公司的Design
export function getDesignListByUserIdAPI(userId) {
  return request({
    url: `/crostars-user/get-design-list-by-userId?userId=${userId}`,
    method: 'POST'
  })
}

//获取所有用户账号信息
export function getUserListAPI() {
  return request({
    url: '/crostars-user/get-user-list',
    method: 'GET'
  })
}

//更新用户权限  
export function updateUserPowerAPI(userId, power) {
  return request({
    url: `/crostars-user/update-user-power?userId=${userId}&power=${power}`,
    method: 'POST'
  })
}

// 获取当前公司所有账号
export function getMyCompanyUsersAPI(){
  return request({
    url: '/crostars-user/get-my-company-users',
    method: 'GET'
  })
}

// 同步更新用户 power / designer / executor （真实接口）
export function updateUserAttributesAPI({ userId, power, designer, executor }){
  return request({
    url: '/crostars-user/update-user-power-by-id',
    method: 'POST',
    data: { userId, power, designer, executor }
  })
}